import { plans, shipping, hardware } from '@/data'

const StandardPlan = plans.find(plan => plan.map_key === 'standard_yearly')
const ProPlan = plans.find(plan => plan.map_key === 'pro_yearly')

// const Quest2Headset = hardware.find(h => h.label === 'Meta Quest 2 Headset')
const Quest3HeadsetStandard = hardware.find(h => h.label === 'Meta Quest 3 Headset' && h.available_for?.includes('standard_yearly'))
const Quest3HeadsetPro = hardware.find(h => h.label === 'Meta Quest 3 Headset' && h.available_for?.includes('pro_yearly'))
const Quest3SHeadsetStandard = hardware.find(h => h.label === 'Meta Quest 3S Headset' && h.available_for?.includes('standard_yearly'))
const Quest3SHeadsetPro = hardware.find(h => h.label === 'Meta Quest 3S Headset' && h.available_for?.includes('pro_yearly'))
const Quest3SHeadsetHoliday = hardware.find(h => h.label === 'Meta Quest 3S Headset' && h.available_for?.includes('pro_yearly_holiday'))

// const Quest2BatAttachment = hardware.find(h => h.category === 'bat_attachment' && h.price === 0 && h.description === 'for Quest 2')
const Quest3BatAttachment = hardware.find(h => h.category === 'bat_attachment' && h.price === 0 && h.description === 'for Quest 3/3S')
const Quest3ShortBat = hardware.find(h => h.category === 'short_bat' && h.price === 7400) // discounted for bundles

export default [
    // // Quest 2
    // {
    //     wc_id: import.meta.env.DEV ? 3404 : 118154,
    //     price: 42900,
    //     bundle_group_key: 'metaquest2023',
    //     description: 'Meta Quest 2 Bundle',
    //     badge: 'Includes Standard Yearly Plan',
    //     plan: {
    //         ...StandardPlan,
    //         price: 0,
    //         hardware_options: [Quest2Headset, Quest2BatAttachment],
    //     },
    //     equipment: [Quest2Headset, Quest2BatAttachment],
    //     shipping_options: shipping.filter(option => option.id === 'standard'),
    // },

    // Quest 3
    {
        wc_id: import.meta.env.DEV ? 7736 : 142267,
        price: 72700,
        bundle_group_key: 'metaquest3-standard',
        description: 'Meta Quest 3 Bundle',
        badge: 'Includes Standard Yearly Plan',
        plan: {
            ...StandardPlan,
            price: 0,
            hardware_options: [Quest3HeadsetStandard, Quest3BatAttachment],
        },
        equipment: [Quest3HeadsetStandard, Quest3BatAttachment],
        shipping_options: shipping.filter(option => option.id === 'standard'),
    },
    {
        wc_id: import.meta.env.DEV ? 7738 : 142266,
        price: 85400,
        bundle_group_key: 'metaquest3-pro',
        description: 'Meta Quest 3 Bundle',
        badge: 'Includes Pro Yearly Plan',
        plan: {
            ...ProPlan,
            price: 0,
            hardware_options: [Quest3HeadsetPro, Quest3BatAttachment],
        },
        equipment: [Quest3HeadsetPro, Quest3BatAttachment],
        shipping_options: shipping.filter(option => option.id === 'standard'),
    },
    {
        wc_id: import.meta.env.DEV ? 8353 : 143828,
        price: 80100,
        bundle_group_key: 'metaquest3-standard-shortbat',
        description: 'Meta Quest 3 Bundle',
        badge: 'Includes Standard Yearly Plan',
        plan: {
            ...StandardPlan,
            price: 0,
            hardware_options: [Quest3HeadsetStandard, Quest3ShortBat],
        },
        equipment: [Quest3HeadsetStandard, Quest3ShortBat],
        shipping_options: shipping.filter(option => option.id === 'standard'),
    },
    {
        wc_id: import.meta.env.DEV ? 8354 : 143829,
        price: 92800,
        bundle_group_key: 'metaquest3-pro-shortbat',
        description: 'Meta Quest 3 Bundle',
        badge: 'Includes Pro Yearly Plan',
        plan: {
            ...ProPlan,
            price: 0,
            hardware_options: [Quest3HeadsetPro, Quest3ShortBat],
        },
        equipment: [Quest3HeadsetPro, Quest3ShortBat],
        shipping_options: shipping.filter(option => option.id === 'standard'),
    },
    {
        wc_id: import.meta.env.DEV ? 8531 : 144849,
        price: 60500,
        bundle_group_key: 'metaquest3-summer',
        description: 'Meta Quest 3 Bundle',
        badge: 'Includes Pro Yearly Plan',
        plan: {
            ...ProPlan,
            price: 0,
            hardware_options: [Quest3HeadsetPro, Quest3BatAttachment],
        },
        equipment: [Quest3HeadsetPro, Quest3BatAttachment],
        shipping_options: shipping.filter(option => option.id === 'standard'),
    },

    // Quest 3S
    {
        wc_id: import.meta.env.DEV ? 9372 : 147765,
        price: 52700,
        bundle_group_key: 'metaquest3s-standard',
        description: 'Meta Quest 3S Bundle',
        badge: 'Includes Standard Yearly Plan',
        plan: {
            ...ProPlan,
            price: 0,
            hardware_options: [Quest3SHeadsetStandard, Quest3BatAttachment],
        },
        equipment: [Quest3SHeadsetStandard, Quest3BatAttachment],
        shipping_options: shipping.filter(option => option.id === 'standard'),
    },
    {
        wc_id: import.meta.env.DEV ? 9373 : 147764,
        price: 65400,
        bundle_group_key: 'metaquest3s-pro',
        description: 'Meta Quest 3S Bundle',
        badge: 'Includes Pro Yearly Plan',
        plan: {
            ...ProPlan,
            price: 0,
            hardware_options: [Quest3SHeadsetPro, Quest3BatAttachment],
        },
        equipment: [Quest3SHeadsetPro, Quest3BatAttachment],
        shipping_options: shipping.filter(option => option.id === 'standard'),
    },
    {
        wc_id: import.meta.env.DEV ? 9374 : 147766,
        price: 60100,
        bundle_group_key: 'metaquest3s-standard-shortbat',
        description: 'Meta Quest 3S Bundle',
        badge: 'Includes Standard Yearly Plan',
        plan: {
            ...ProPlan,
            price: 0,
            hardware_options: [Quest3SHeadsetStandard, Quest3ShortBat],
        },
        equipment: [Quest3SHeadsetStandard, Quest3ShortBat],
        shipping_options: shipping.filter(option => option.id === 'standard'),
    },
    {
        wc_id: import.meta.env.DEV ? 9375 : 144767,
        price: 72800,
        bundle_group_key: 'metaquest3s-pro-shortbat',
        description: 'Meta Quest 3S Bundle',
        badge: 'Includes Pro Yearly Plan',
        plan: {
            ...ProPlan,
            price: 0,
            hardware_options: [Quest3SHeadsetPro, Quest3ShortBat],
        },
        equipment: [Quest3SHeadsetPro, Quest3ShortBat],
        shipping_options: shipping.filter(option => option.id === 'standard'),
    },
    {
        wc_id: import.meta.env.DEV ? 9308 : 147701,
        price: 54800,
        bundle_group_key: 'metaquest3s-holiday',
        description: 'Meta Quest 3S Bundle',
        badge: 'Includes Pro Yearly Plan',
        plan: {
            ...ProPlan,
            price: 0,
            hardware_options: [Quest3SHeadsetHoliday, Quest3BatAttachment],
        },
        equipment: [Quest3SHeadsetHoliday, Quest3BatAttachment],
        shipping_options: shipping.filter(option => option.id === 'standard'),
    },
] as Bundle[]